import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, XCircle, Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    if (!sessionId) { setStatus("error"); return; }
    let attempts = 0;
    const poll = async () => {
      attempts += 1;
      try {
        const res = await api.get(`/payments/status/${sessionId}`);
        if (res.data.payment_status === "paid") { setStatus("paid"); return; }
        if (["expired", "failed"].includes(res.data.payment_status)) { setStatus("error"); return; }
      } catch { setStatus("error"); return; }
      if (attempts >= 8) { setStatus("pending"); return; }
      setTimeout(poll, 2000);
    };
    poll();
  }, [sessionId]);

  return (
    <div className="max-w-xl mx-auto px-5 py-24 text-center" data-testid="payment-success">
      {status === "checking" && (
        <div className="brut-card p-10">
          <Loader2 className="w-12 h-12 mx-auto animate-spin mb-4" />
          <h1 className="font-display font-bold text-3xl">Confirming your payment…</h1>
        </div>
      )}
      {status === "paid" && (
        <div className="brut-card p-10 bg-sun/40">
          <CheckCircle2 className="w-16 h-16 mx-auto text-green-600 mb-4" />
          <h1 className="font-display font-bold text-4xl">Payment received! 🎉</h1>
          <p className="text-ink/70 mt-3 text-lg">A receipt is on its way to your inbox. We'll start drawing right away!</p>
          <Link to="/" className="brut-btn bg-bubble text-white mt-8 inline-flex">Back home</Link>
        </div>
      )}
      {status === "pending" && (
        <div className="brut-card p-10">
          <Loader2 className="w-12 h-12 mx-auto mb-4" />
          <h1 className="font-display font-bold text-3xl">Still processing…</h1>
          <p className="text-ink/70 mt-3">This is taking a moment. You'll get an email once it clears.</p>
          <Link to="/" className="brut-btn bg-white mt-6 inline-flex">Back home</Link>
        </div>
      )}
      {status === "error" && (
        <div className="brut-card p-10">
          <XCircle className="w-16 h-16 mx-auto text-red-500 mb-4" />
          <h1 className="font-display font-bold text-3xl">Hmm, we couldn't confirm that.</h1>
          <Link to="/order" className="brut-btn bg-sun mt-6 inline-flex">Try again</Link>
        </div>
      )}
    </div>
  );
}
